module.exports = __webpack_public_path__ + "img/foerderlogo.57afb35c.jpg";